import { isSameDay } from 'date-fns';
import { ApiTransaction } from '../../../openapi';

export type TransactionGroup = {
  date: Date;
  transactions: ApiTransaction[];
};

export function groupTransactionsByDate(
  pages: { transactions: ApiTransaction[] }[],
): TransactionGroup[] {
  const groups: TransactionGroup[] = [];
  let currentGroup: TransactionGroup | null = null;
  for (const page of pages) {
    for (const transaction of page.transactions) {
      const created = new Date(transaction.date.created);
      if (currentGroup && isSameDay(currentGroup.date, created)) {
        currentGroup.transactions.push(transaction);
      } else {
        currentGroup = { date: created, transactions: [transaction] };
        groups.push(currentGroup);
      }
    }
  }

  return groups;
}
